import {
  Keyboard,
  KeyboardAvoidingView,
  Platform,
  Pressable,
  StatusBar,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useState } from "react";
import { useNavigation } from "@react-navigation/native";
import { SafeAreaView } from 'react-native-safe-area-context'

import { login } from "../../../services/Auth/authService";
import { setLoggedIn } from "../../../redux/auth/authSlice";
import { dispatch } from "../../../redux/store";
import { styles } from "../auth.style";
import TopIconView from "../components/TopIconView";
import AuthIcons from "../../../assets/Icons/AuthIcons";
import CustomComponent from "../../../components/CustomComponent";
import GlobalStyles from "../../../globalStyles/globalStyles";
import BottomView from "../../../components/GlobalComponents/BottomView";
import ForgotPassword from "../../../modal/AuthModals/ForgotPassword";
import { Colors } from "../../../globalStyles/ColorConfig";

type PasswordAuthProps = {
  route: any;
  navigation: any;
};
// import { useNavigation } from "@react-navigation/native";

const PasswordAuth = ({ route, navigation }: PasswordAuthProps) => {
  const { mail } = route.params;

  const [password, setPassword] = useState("");
  const [isforgotVisible, setForgotVisible] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [errorTitle, setErrorTitle] = useState<string>('');

  // const toggleForgotPassword = () => {
  //   setForgotVisible(!isforgotVisible)
  // }

  const handlePasswordChange = (text: string) => {
    setPassword(text);
    setPasswordError(false)
  };

  const handleSumbitPassword = async () => {
    const credentials = {
      email: mail,
      password: password,
    };
    try {
      const response: any = await login(credentials);
      console.log(response)
      if(response?.data){
        // save token 
        dispatch(setLoggedIn({
          accessToken: response?.data?.accessToken?.accessTokenJWT,
          refreshToken: response?.data?.refreshToken?.refreshTokenJWT
        }))
      }
      if(response?.message == 'Login successful! Please verify your phone number!' || response?.error == "Please verify your email first!"){ // remove the second statement
        navigation.navigate("auth-mobile", {mail})
      }
    } catch (error) {
      setPasswordError(true);
      setErrorTitle("Incorrect Password!");
    }
  };

  const validatePassword = () => {
    if (!password) {
      setPasswordError(true);
      setErrorTitle("This field is required!");
      return false;
    }
    return true;
  };

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar barStyle="dark-content" backgroundColor={Colors.white000} />
        <Pressable style={{flex: 1}} onPress={Keyboard.dismiss}>
          <View style={styles.mobileAuthView}>
            <TopIconView icon={<AuthIcons.PasswordIcon />} password={true} />
            <View style={{gap: 6}}>
              <CustomComponent.TextView
                title="Enter your password"
                textStyle={GlobalStyles.heading3}
              />
              <CustomComponent.TextView
                title="You need to enter password for"
                textStyle={GlobalStyles.bodyText}
              >
                <TouchableOpacity onPress={() => navigation.goBack()}>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      top: 1,
                    }}
                  >
                    <Text style={[styles.subText, styles.subHeader]}>{mail}</Text>
                    <AuthIcons.EditIcon />
                  </View>
                </TouchableOpacity>
              </CustomComponent.TextView>
            </View>
            <View
              style={{
                height: 60,
                width: '100%',
                top: 20,
              }}
            >
              <CustomComponent.InputField
                placeholder="Enter password"
                keyboardtype="default"
                width={328}
                height={50}
                onTextChange={handlePasswordChange}
                password={true}
                error={passwordError}
                InputStyle={{
                  paddingRight: 10
                }}
              />
            </View>
            {passwordError && (
                <CustomComponent.TextView
                  title={errorTitle}
                  textStyle={[GlobalStyles.captionText, { color: Colors.red10, marginTop: 10 }]}
                />
            )}
            {/* <CustomComponent.TextView textStyle={GlobalStyles.bodyText}>
              <TouchableOpacity onPress={toggleForgotPassword}>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Text style={[styles.subText, styles.subHeader]}>
                    Forgot password?
                  </Text>
                </View>
              </TouchableOpacity>
            </CustomComponent.TextView> */}
          </View>
          <BottomView
            enableTitle={false}
            onPress={()=> validatePassword() && handleSumbitPassword()}
            disableBtn={true}
            style={{paddingBottom: 20}}
          />
        </Pressable>
      {/* { isforgotVisible &&
        <ForgotPassword
          toggleModal={toggleForgotPassword} 
        />
      } */}
    </SafeAreaView>
  );
};

export default PasswordAuth;
